<template>
  <div id="wrapper" class="noheader">
    <div class="nav">
      <div class="inner">
        <a class="btn" @click.prevent="open('會員帳號')"
          ><div class="inner">
            <div class="nav_img">
              <img
                class="account"
                src="@/assets/images/nav_icon/nav_icon_account.svg"
              />
            </div>
            <p>會員帳號</p>
          </div></a
        >
        <a class="btn" @click.prevent="$router.replace('/Appointment')"
          ><div class="inner">
            <div class="nav_img">
              <img
                class="reservation"
                src="@/assets/images/nav_icon/nav_icon_reservation.svg"
              />
            </div>
            <p>預約掛號</p>
          </div></a
        >
        <a class="btn" @click.prevent="$router.replace('/AppointmentQuery')"
          ><div class="inner">
            <div class="nav_img">
              <img
                class="search"
                src="@/assets/images/nav_icon/nav_icon_search.svg"
              />
            </div>
            <p>掛號查詢</p>
          </div></a
        >
        <a class="btn" @click.prevent="$router.replace('/WaitInfo')"
          ><div class="inner">
            <div class="nav_img">
              <img
                class="scope"
                src="@/assets/images/nav_icon/nav_icon_scope.svg"
              />
            </div>
            <p>看診進度</p>
          </div></a
        >
        <!-- <a class="btn" @click.prevent="$router.replace('/Notification')"> -->
        <a class="btn" @click.prevent="open('推播設定')">
          <div class="inner">
            <div class="nav_img">
              <img
                class="notification"
                src="@/assets/images/nav_icon/nav_icon_notification.svg"
              />
            </div>
            <p>推播設定</p>
          </div></a
        >
        <a
          class="btn"
          @click="openWindow('https://liff.line.me/1655966565-o9M0b7xJ', false)"
          ><div class="inner">
            <div class="nav_img">
              <img
                class="board"
                src="@/assets/images/nav_icon/nav_icon_board.svg"
              />
            </div>
            <p>檢驗資料</p>
          </div></a
        >
        <a class="btn" @click.prevent="$router.replace('/FeedBack')"
          ><div class="inner">
            <div class="nav_img">
              <img
                class="suggestion"
                src="@/assets/images/nav_icon/nav_icon_suggestion.svg"
              />
            </div>
            <p>意見反映</p>
          </div></a
        >
        <a
          class="btn"
          v-if="member?.info?.operation"
          @click.prevent="$router.replace('/Operation')"
          ><div class="inner">
            <div class="nav_img">
              <!-- 待確認 -->
              <img
                class="anesthesia"
                src="@/assets/images/nav_icon/nav_icon_anesthesia.svg"
                alt="手術清單"
              />
            </div>
            <p>手術清單</p>
          </div></a
        >
        <!-- <a class="btn" @click.prevent="open('預約課程')"
          ><div class="inner">
            <div class="nav_img">
              <img
                class="lesson"
                src="@/assets/images/nav_icon/nav_icon_lesson.svg"
              />
            </div>
            <p>預約課程</p>
          </div>
        </a> -->
      </div>
    </div>
  </div>

  <modal v-if="modal.display" @close="modal.display = false">
    <template v-slot:header v-if="modal.header">{{ modal.header }}</template>
    <template v-slot:body>{{ modal.body }}</template>
  </modal>

  <debug v-if="debug">{{ from.path }}</debug>
</template>

<script>
import liff from "@line/liff";

export default {
  data() {
    return {
      debug: eval(process.env.VUE_APP_DEBUG),
      loading: true,
      modal: {}
    };
  },
  mounted() {
    this.params = this.$route.params;
  },
  computed: {
    member() {
      return this.$store.state.member;
    },
    from() {
      return this.$store.state.from;
    }
  },
  methods: {
    open(page) {
      let message = "很抱歉，此功能尚未開放，敬請期待。";
      if (page === "會員帳號") {
        message = this.member.info.verified
          ? `帳號(${this.member.info.patientNo})已與LINE完成綁定。`
          : `您尚未完成LINE帳號綁定，請回首頁開始綁定。`;
      }
      this.modal = {
        display: true,
        header: page,
        body: message
      };
    },
    openWindow(url, external) {
      liff.openWindow({
        url: url,
        external: external
      });
    }
  }
};
</script>
